<template>
  <modal titulo="Odin - Editar Minuta" id="odin-processamento-ato"
         :fechar="true" @close="close" >
    <template #default>
      <div class="row gutters-xs ato">
        <v-input
          class="col-12"
          type="classic-editor"
          v-model="form.texto"
        />
      </div>
    </template>

    <template #footer>
      <button
        class="btn btn-outline-secondary mr-auto"
        type="button"
        @click.prevent="close(false)"
      >
        Cancelar
      </button>
      <v-button
        class="btn-outline-primary"
        :run="salvar"
        :popover="true"
      >
        Salvar
      </v-button>
    </template>
  </modal>
</template>

<script setup>

import { reactive } from 'vue';
import Modal from '@/components/Modal.vue';
import FrontBusiness from "@/business/FrontBusiness";

const props = defineProps({
  ato: Object,
});

const form = reactive({
  ...props.ato,
})

const close = (retorno) => {
  FrontBusiness.closeModal(retorno);
}

const salvar = async () => {
  close(form)
}

</script>
